<template>
  <div class="q-pa-sm">

    <!-- <div>全局视图 <span>>李四视图</span></div>
    <el-divider class="in"></el-divider> -->
    <!--    <div class="view">-->
    <!--      <div class="view_1">-->
    <!--        <div>-->
    <!--          <div>未开始</div>-->
    <!--          <div class="view_4">{{ divData.weikaishi }}</div>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <div>进行中</div>-->
    <!--          <div class="view_4">{{ divData.jingxingzhong }}</div>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <div>已完成</div>-->
    <!--          <div class="view_4">{{ divData.yiwancheng }}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="view_1">-->
    <!--        <div>-->
    <!--          <div>延期未完成</div>-->
    <!--          <div class="view_4">{{ divData.yanqiwei }}</div>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <div>延期已完成</div>-->
    <!--          <div class="view_4">{{ divData.yanqiwang }}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="view_1">-->
    <!--        <div class="view_3">-->
    <!--          <el-progress-->
    <!--            type="dashboard"-->
    <!--            :percentage="divData.wangchenglu"-->
    <!--            :color="colors"-->
    <!--          ></el-progress>-->
    <!--          <div>完成率</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="view">
      <div class="view_1">
        <div>
          <div>
            未开始
          </div>
          <div class="view_4">{{divData.weikaishi}}</div>
        </div>
      </div>
      <div class="view_1">
        <div>
          <div>进行中</div>
          <div class="view_4">{{divData.jingxingzhong}}</div>
        </div>
      </div>
      <div class="view_1">
        <div>
          <div>已完成</div>
          <div class="view_4">{{divData.yiwancheng}}</div>
        </div>
      </div>

      <div class="view_1">
        <div>
          <div style="color:red">延期未完成</div>
          <div class="view_4">{{divData.yanqiwei}}</div>
        </div>
      </div>
      <div class="view_1">
        <div>
          <div>延期已完成</div>
          <div class="view_4">{{divData.yanqiwang}}</div>
        </div>
      </div>
      <div class="view_1">
        <div class="view_3">
          <el-progress type="dashboard" :percentage="divData.wangchenglu" :color="colors"></el-progress>
          <div>完成率</div>
        </div>
      </div>
    </div>

    <gantt-elastic
      v-if="showTasks"
      :options="options"
      :tasks="tasks"
      style="margin-top: 20px"
      class="gante"
    >
    </gantt-elastic>
    <div>
      <el-dialog
              :title="mytaskbyid.name"
              :visible.sync="editFormVisible"
              class="edit-dialog"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
            >
              <!--      头部信息      -->
              <div class="dialog-data1">
                <div class="dialog-data2">
                  <div class="font-icon beijinyuan"><i class="el-icon-time"></i></div>
                  <!--                  <div><span>{{mytaskbyid.status == 1?'未开始':mytaskbyid.status == 2?'进行中':'已完成'}}</span><br/><span>当前状态</span></div>-->
                  <div>
                    <template>
                      <el-select class="minFont1" v-model="mytaskbyid.status"
                                 @change="((value)=>{updateStatus(value, mytaskbyid.id)})">
                        <el-option
                        disabled
                          v-for="items in typeList"
                          :key="items.id"
                          :label="items.name"
                          :value="items.id">
                        </el-option>
                      </el-select>
                    </template>
                    <br/>
                    <span class="minFont">当前状态</span>
                  </div>
                </div>
                <div class="dialog-data2">
                  <div class="font-icon">
                    <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" style="height: 40px;width:40px;border-radius: 50%" v-if="mytaskbyid.charger_avatar==''||mytaskbyid.charger_avatar==undefined"></el-image>
                    <el-avatar :src="mytaskbyid.charger_avatar.substr(0,4) == 'http' ? mytaskbyid.charger_avatar : $url.img + mytaskbyid.charger_avatar" :key="mytaskbyid.charger_avatar.substr(0,4) == 'http' ? mytaskbyid.charger_avatar : $url.img + mytaskbyid.charger_avatar" v-else></el-avatar>

                  </div>
                  <div><span class="minFont1">{{mytaskbyid.charger_name}}</span><br/><span class="minFont">负责人</span></div>
                </div>
                <div class="dialog-data2">
                  <div class="font-icon beijinyuan"><i class="el-icon-date"></i></div>
                  <div><span class="minFont1">{{mytaskbyid.start_time}}</span><br/><span class="minFont">开始时间</span>
                  </div>
                </div>
                <div class="dialog-data2">
                  <div class="font-icon beijinyuan"><i class="el-icon-folder-checked"></i></div>
                  <div>
                    <!--                    <span class="minFont1">{{}}</span>-->
                      <el-date-picker
                      class="minFont1"
                      @change="updateTime(mytaskbyid.id,mytaskbyid.project_id)"
                      v-model="mytaskbyid.end_time"
                      value-format="yyyy-MM-dd"
                      type="date"
                      :picker-options="pickerOptions"
                      placeholder="选择日期">
                    </el-date-picker>
                    <br/><span class="minFont">结束时间</span></div>
                </div>
              </div>
              <el-divider></el-divider>
              <!--     分割线下的信息       -->
              <el-form :inline="true" class="demo-form-inline form-text">
                <el-form-item label="项目名称">
                  <el-input disabled v-model="mytaskbyid.name"></el-input>
                </el-form-item>
                <el-form-item label="优先等级">
                  <el-select v-model="priority" @change="updateTa(mytaskbyid.id,mytaskbyid.project_id)">
                    <el-option
                      disabled
                      v-for="item in xuanze"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <div style="height: 1px;width: 10px"></div>
                <el-form-item label="参与人" class="lefta">
                  <span v-for="(t,index) in mytaskbyidTask" :key="index">
                    <el-image :src="'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'" style="height: 40px;width:40px;border-radius: 50%;margin-left:5px" v-if="t.user_avatar==''||t.user_avatar==undefined"></el-image>
                    <el-avatar :src="t.user_avatar.substr(0,4) == 'http' ? t.user_avatar : $url.img + t.user_avatar" v-else></el-avatar>&nbsp;
                  </span>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input disabled v-model="mytaskbyid.remark" :rows="2" type="textarea"></el-input>
                </el-form-item>
              </el-form>
            </el-dialog>
    </div>
  </div>
</template>


<script>
  import GanttElastic from "gantt-elastic";
  import GanttHeader from "gantt-elastic-header";
  import dayjs from "dayjs";
  import {gettimetask, gettaskbyid, getusertask} from "../../api/view";
  import {updateST, updateTask} from "../../api/myTask";
  import {getstatuss} from "../../api/setting";

  // just helper to get current dates
  function getDate(hours) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();
    const timeStamp = new Date(
      currentYear,
      currentMonth,
      currentDay,
      0,
      0,
      0
    ).getTime();
    return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
  }

  let that;
  let tasks = [
    {
      id: 1,
      label: "Make some noise",
      start: getDate(-24 * 5),
      duration: 4 * 24 * 60 * 60 * 1000,
      percent: 85,
      type: "milestone",
      collapsed: true,
    },
    {
      id: 2,
      label: "With great power comes great responsibility",
      start: getDate(-24 * 4),
      duration: 4 * 24 * 60 * 60 * 1000,
      percent: 50,
      type: "milestone",
      collapsed: true,
      style: {
        base: {
          fill: "#1EBC61",
          stroke: "#0EAC51",
        },
      },
    },
  ];
  let options = {
    locale: {
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      months: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ],
    },
    taskMapping: {
      progress: "percent",
    },
    maxRows: 50,
    maxHeight: 550,
    title: {
      label: "Your project title as html (link or whatever...)",
      html: false,
    },
    row: {
      height: 24,
    },
    calendar: {
      hour: {
        display: true,
      },
    },
    chart: {
      progress: {
        bar: false,
      },
      expander: {
        display: false,
      },
    },
    taskList: {
      expander: {
        straight: false,
      },
      columns: [
        {
          id: 2,
          label: "任务(点击可查看详情)",
          value: "label",
          align: "center",
          width: 140,
          html: true,
          events: {
            click({data, column}) {
              that.handleEdit(data.test_id);
            },
          },
        },
      ],
    },
  };
  export default {
    data() {
      return {
        //列表数据
        percentage: 10,
        tableData: [],
        divData: [],
        jindutiao: [],
        user_id: this.$route.query.user_id,
        colors: [
          {color: "#f56c6c", percentage: 20},
          {color: "#e6a23c", percentage: 40},
          {color: "#5cb87a", percentage: 60},
          {color: "#1989fa", percentage: 80},
          {color: "#6f7ad3", percentage: 100},
        ],
        xuanze: [
          {
            value: "2",
            label: "加急",
          },
          {
            value: "3",
            label: "最高",
          },
          {
            value: "4",
            label: "较高",
          },
          {
            value: "1",
            label: "普通",
          },
        ],
        // 优先级
        priority: "",
         //获取每个弹窗的开始时间
        idTime:'',
          //禁用当前时间之前的时间
        pickerOptions: {
          disabledDate :(time)=> {
            return time.getTime() < new Date((this.idTime+' 00:00:00')).getTime() // 选当前时间之前的时间
          }
        },
        //  状态下拉
        typeList: [
          {
            label: "完成",
            value: 3,
          },
          {
            label: "进行中",
            value: 2,
          },
          {
            label: "未开始",
            value: 1,
          },
        ],
        mytaskbyidTask: {},
        //弹框
        editFormVisible: false,
        //弹框数据
        fromData: [],
        //弹框数据——项目参与人
        fromName: [],
        //弹框数据
        mytaskbyid: {},
        tasks,
        options,
        showTasks: false,
      };
    },
    components: {
      GanttElastic,
      GanttHeader,
    },
    //
    methods: {
       dateFormat(fmt, date) {
        let ret = "";
        date = new Date(date);
        const opt = {
          'Y+': date.getFullYear().toString(), // 年
          'm+': (date.getMonth() + 1).toString(), // 月
          'd+': date.getDate().toString(), // 日
          'H+': date.getHours().toString(), // 时
          'M+': date.getMinutes().toString(), // 分
          'S+': date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(
              ret[1],
              ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
            )
          }
        }
        return fmt
      },
      handleEdit(id) {
        let params = {
          token: localStorage.getItem("token"),
          id: id,
        };
        this.editFormVisible = true;
        gettaskbyid(params).then((res) => {
          // console.log(res)
          if (res.errno === 0) {
            this.mytaskbyid = res.data;
            this.idTime = res.data.start_time
             this.mytaskbyidTask = res.data.taskuser
            this.priority =
              res.data.priority == 1
                ? "普通"
                : res.data.priority == 2
                ? "加急"
                : res.data.priority == 3
                  ? "最高"
                  : "较高";
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      ploview() {
        this.$router.push({
          path: "/work/pleview",
        });
      },
      //甘特图数据
      getData() {
        let params = {
          token: localStorage.getItem("token"),
          user_id: this.user_id,
        };
        getusertask(params).then((res) => {
          if (res.errno === 0) {

            this.divData = res.data;

            var temp = res.data.task;
            this.tasks = [];
            var sum = 0;
            if (temp != "") {
              for (var i in temp) {
                if (temp[i].id == "" || temp[i].id == undefined) {
                  continue;
                } else {
                  temp[i].start_time = new Date(
                    temp[i].start_time.replace(/-/g, "/")
                  );
                  temp[i].end_time = new Date(
                    temp[i].end_time.replace(/-/g, "/")
                  );
                  sum += 1;
                  var obj = {
                    project_name: temp[i].project_name,
                    id: sum,
                    test_id: temp[i].id,
                    label: temp[i].name,
                    user: temp[i].user_ids,
                    start: new Date(temp[i].start_time).getTime(),
                    end: new Date(temp[i].end_time).getTime(),
                    Status: temp[i].status,
                    duration:
                      new Date(temp[i].end_time).getTime() -
                      new Date(temp[i].start_time),
                    type: "milestone",
                    percent: 100,
                  };
                  for (var m in this.allstatu) {
                  let lcsd = {
                    base: {
                      fill: "",
                      stroke: "",
                    },
                  };
                  if (temp[i].status == this.allstatu[m].id) {
                    lcsd.base.fill = this.allstatu[m].color;
                    lcsd.base.stroke = this.allstatu[m].color;
                    obj.style = lcsd;
                    obj.Status =
                      '<span class="jingxing1">' +
                      this.allstatu[m].name +
                      "</span>";
                    this.tasks.push(obj);
                  }
                }
                }
              }
            }
            if (this.tasks.length > 0) {
              this.showTasks = true;
            }
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      getData1() {
        let params = {
          token: localStorage.getItem("token"),
          user_id: this.user_id,
        };
        getusertask(params).then((res) => {
          if (res.errno === 0) {
            this.divData = res.data;
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      //编辑状态
      updateStatus(val, id) {
        let params = {
          token: localStorage.getItem("token"),
          id: id,
          status: val,
        };
        // console.log(params);
        updateST(params).then((res) => {
          if (res.errno === 0) {
            this.$message({
              message: "状态修改成功",
              type: "success",
            });
            this.getData()

          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      updateTa(id, project_id) {
        let params = {
          token: localStorage.getItem("token"),
          id: id,
          project_id: project_id,
          priority: this.priority,
        };
        // console.log(params)
        updateTask(params).then((res) => {
          if (res.errno === 0) {
            this.$message({
              message: '优先等级修改成功',
              type: 'success'
            });
            this.getData()
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.data);
          }
        });
      },
      optionsUpdate(options, num) {
        if (num == 2) {
          this.options = options;
        }
      },
       //修改时间
      updateTime(id, project_id) {
        let params = {
          token: localStorage.getItem("token"),
          id: id,
          project_id: project_id,
          end_time: this.dateFormat('YYYY-mm-dd', this.mytaskbyid.end_time)
        };
        if ((new Date((this.mytaskbyid.end_time).toString().replace(/-/g, "/"))) >= (new Date((this.mytaskbyid.start_time).toString().replace(/-/g, "/")))) {

          updateTask(params).then((res) => {
            if (res.errno === 0) {
              this.$message({
                message: '时间修改成功',
                type: 'success'
              });
              this.getData()
            } else if (res.errno === 401) {
              this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
            } else {
              this.$message.error(res.data);
            }
          });
        } else {
          this.$message({
            message: '结束时间不得小于开始时间',
            type: 'error'
          });
        }
      },
      //状态颜色
      getstatu() {
        let params = {
          token: localStorage.getItem("token"),
          page: this.currentPage3,
        };
        getstatuss(params).then((res) => {
          if (res.errno === 0) {
            this.allstatu = res.data.data;
            this.typeList=res.data.data
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.errno);
          }
        });
      },
    },
    mounted() {
      this.getstatu()
      this.getData();
      // this.getData1();
      that = this;
    },
    created(){
        this.getstatu()
      this.getData()
    },
  };
</script>
<style scoped>
  .q-pa-sm {
    background-color: #fbfbfb;
  }

  .q-pa-sm >>> .in {
    margin: 15px 0;
  }

  .q-pa-sm >>> .in_2 {
    margin: 15px 0;
  }

  .q-pa-sm >>> .in {
    margin: 15px 0;
  }

  .view {
    display: flex;
    padding: 20px;
    text-align: center;
    background-color: #ffffff;
    /*box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);*/
  }

  .view_1 {
    display: flex;
    padding: 5px 0;
    text-align: center;
    align-items: center;
    border-right: 1px solid #eff2f6;
    width: 50%;
    box-sizing: border-box;
    justify-content: space-around;
    color: #141464;
    font-size: 16px;
    font-weight: bold;
  }

  .view_3 >>> .el-progress-circle {
    height: 77px !important;
    width: 80px !important;
  }

  .view_4 {
    font-size: 30px;
    margin-top: 10px;
  }


  .q-pa-sm >>> .el-dialog {
    width: 50%;
    min-height: 400px;
  }

  .minFont {
    color: #888888;
    font-size: 14px;
  }

  .minFont1 {
    color: #333333;
    font-size: 16px;
  }

  .el-dialog__header {
    padding: 45px 20px 10px;
  }

  .form-text {
    display: flex;
    position: relative;
    justify-content: space-between;
    flex-wrap: wrap;
    text-decoration: none;
    margin: 0 50px;
  }


  .edit-dialog >>> .el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 10px;
    width: 46%;
    vertical-align: top;
  }

  .q-pa-sm >>> .el-dialog__title {
    font-size: 20px;
    color: #141464;
    font-weight: 700;
  }

  .q-pa-sm >>> .el-dialog__headerbtn {
    top: 3px;
    right: 3px;
    font-size: 25px;
  }

  .view div:nth-child(6) {
    border-right: none;
  }

  .edit-dialog >>> .el-input.is-disabled,
  .edit-dialog >>> .el-input__inner {
    width: 100%;
    height: 30px;
    background-color: #ffffff;
    border-color: #cccccc;
    color: #666666;
    border-radius: unset;
    cursor: not-allowed;
  }

  .edit-dialog >>> .el-select .el-input__inner {
    cursor: pointer;
  }

  .edit-dialog >>> .el-textarea__inner {
    width: 100%;
    background-color: #ffffff;
    border-color: #cccccc;
    color: #666666;
    border-radius: unset;
    cursor: not-allowed;
  }

  .lefta {
    margin-left: 13px;
  }

  .beijinyuan {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    background-color: #f2f6ff;
  }

  .beijinyuan >>> i {
    position: relative;
    left: 8px;
    top: 2px;
    color: #2b51e8;
  }

  /*.leftb{*/
  /*  position: absolute;*/
  /*  top: 62px;*/
  /*  left: 12px;*/
  /*}*/

  .dialog-data1 {
    display: flex;
    justify-content: space-between;
    padding: 0 50px;
  }

  .dialog-data2 {
    display: flex;
  }

  .font-icon {
    font-size: 26px !important;
    margin-right: 10px;
  }

  .min-data i {
    font-size: 17px;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 160px;
    color: #ff606d;
    cursor: pointer !important;
  }

  .dialog-data2 >>> .el-input__inner {
    border: none;
    padding: 0;
    width: 120px;
    color: #333333;
    font-size: 16px;
    height: 21px;
    color: #ff606d;
    cursor: pointer !important;
  }

  .dialog-data2 >>> .el-select span,
  .dialog-data2 >>> .el-date-editor span {
    display: none;
  }

  .el-table {
    margin-top: 35px;
  }

  .wangle >>> input {
    border: none !important;
    padding: 0 !important;
    width: 80px;
    border-radius: unset;
    background: none;
    font-size: 16px;
  }

  .wangle >>> span {
    display: none;
  }
  .q-pa-sm >>> .gantt-elastic__task-list-item-value{
    cursor: pointer;
  }
/* 导航栏 */
/* 居中 */
.gante >>> .gantt-elastic__task-list-item-value-container {
  margin: auto !important;
  text-align: center !important;
}
.gante >>> .gantt-elastic__task-list-header-column {
  text-align: center;
  background-color: #f5f5f5 !important ;
}
.gante >>>.gantt-elastic__calendar{
  background-color: #f5f5f5 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/work/peodetail.vue